import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";


type Props = {
    visible: boolean;
    onHide: () => void;
    nomeRelatorio: string;
    urlRelatorio?: string;
}

export default function ModalVerRelatorio(props: Props) {
   
    const footer = <div>
        <Button label="Fechar" icon="pi pi-times" className="p-button-text p-button-danger" onClick={props.onHide} />
    </div>


    return (
        <>
            <Dialog visible={props.visible} baseZIndex={1000} style={{ width: window.innerWidth - 100, height: window.innerHeight - 100 }} modal onHide={props.onHide}
                header={props.nomeRelatorio} footer={footer}>
                <embed type="application/pdf" src={props.urlRelatorio} style={{ width: "100%", height: "98%" }} title={props.nomeRelatorio} ></embed>
            </Dialog>
        </>
    )
}